// extracted by mini-css-extract-plugin
export default {"link":"StyledLink_link__aJ4Qo","underline":"StyledLink_underline__AATVC","bold":"StyledLink_bold__qD3z6"};